import loadings from './loading.vue'
import { ag,agDz, ap, letter, performance, ahGzDzBank } from '../../util/modalData'
import {myTimeToLocal} from '../../util/formatDate'
import { ApplyType } from '@/shared/type'
const load = {}

// 注册Toast
load.install = function (Vue) {
  const loadingConstructor = Vue.extend(loadings)
  const instance = new loadingConstructor()
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  const propsBfeetsData = (type) => {
    let types = {
      '7000': ag,
      '7000_dz': agDz,
      '9600': letter,
      '8000': ap,
      '8000_AhGz': ahGzDzBank,
      '9100': performance,
    }
    return types[type]
  }
  const filter = (data1, types) => {
    let outputData = []
    for (let  [key, value] of Object.entries(propsBfeetsData(types))) {
      for (let  [keys, values] of Object.entries(data1)) {
        if (keys == key) {
          //时间类型转化
          if(key === 'guaranteeStartDate'){
           values = myTimeToLocal(values)
          }
          outputData.push({
            key: value,
            value: values,
          })
        }
      }
    }
    return outputData
  }
  const show = (can, types) => {
    return new Promise((resolve, reject) => {
      instance.visible = true
      instance.data1 = filter(can, types)
      instance.title = `${ApplyType[types]?.n ?? (types?.length > 3 ? ApplyType[types.slice(0, -3)]?.n_dz : null) ?? ''}信息确认`;
      instance.$watch(
        () => instance.visible,
        (visible) => {
          if (!visible && instance.isSubmit) {
            resolve()
          } else {
            reject()
          }
        }
      )
    })
  }
  //将方法挂载全局
  Vue.prototype.$showAffirm = show
}

export default load
